import React from 'react'
import './pageheaderIntro.scss'
import { Row, Col } from 'react-bootstrap'
const PageIntro = ({  Data,  showImage = "true" , heading}) => {

  return (
    <>
      <div className='pageheaderinfo'>
        <Row>
          <Col sm={12} md={12} lg={6} xl={8}>
            <div className='left-details'>
              <div className='Heading'>
                <h3>{heading}</h3>
              </div>
              <div className='text'>
                {Data.map((item) => (
                  <>
                    <p>{item.para}</p>
                    <p>{item.para1}</p>
                    <p>{item.para2}</p>
                  </>
                ))}
              </div>
            </div>
          </Col>
          {showImage && (
            <Col sm={12} md={6} lg={6} xl={4}>
              {Data.map((item) => (
                <div className='right-image'>
                  <img src={item.image} alt='logo' />
                </div>
              ))}
            </Col>
          )}
        </Row>
      </div>
    </>
  )
}

export default PageIntro